import Leaderboard from "../../../components/leaderboard/leaderboardtable";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";

function HighSchoolLeaderboardPage() {
  const authUser = useAuthUser();

  return (
    <div className="p-4 h-full bg-gray-100">
      <Leaderboard highSchool={authUser?.user.highSchool} />
    </div>
  );
}

export default HighSchoolLeaderboardPage;
